import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Flex, Box } from 'grid-styled';
import isFunction from 'lodash/isFunction';

/* Material UI */
import Checkbox from 'material-ui/Checkbox';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';

/* COMPONENTS */
import ProductListImage from '../ProductListImage/ProductListImage';
// import ReviewStars from '../../Reviews/ReviewStars';
import ProductListItemToggleButton from './ProductListItemToggleButton';
import ProductListItemName from './ProductListItemName';

/* Helpers */
import {
  currentPrice,
  getButtonStyles,
  getNonEligibleSkuText,
} from '../../../../utils/productFunctions';
import { urlSquareShopProduct } from '../../../../../server/utils/urlConstants';
// import { tablet } from '../../../../utils/deviceWidths';
import findProductCartQty from '../../Utility/findProductCartQty';
// productCartQtyChanged,
// productWishlistQtyChanged,
import { subscriptionProductIds } from '../../../../../common/sharedConstants/subscriptionProductConstants';

/* Style */
import { withCase4CauseToggle } from '../../../_common/_context/Case4CauseToggle';

import './ProductListItem.scss';

const ImpactText = ({ impactSmall }) => {
  if (impactSmall) {
    return (
      <Box className="impact-summary">
        <span className="impact-provides-text">Supports: &nbsp;</span>
        {impactSmall}
      </Box>
    );
  }
  return <Box className="impact-summary" />;
};

const propTypes = {
  category: PropTypes.string,
  shopNavOpen: PropTypes.bool,
  showAddToCart: PropTypes.bool,
  isVerticallyCentered: PropTypes.bool,
  relay: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  containerWidth: PropTypes.number.isRequired,
  handleCartAddClick: PropTypes.func,
  handleAuthentication: PropTypes.func,
  handleRouteChange: PropTypes.func.isRequired,
  hidePlusMinus: PropTypes.bool,
  onProductClick: PropTypes.func,
  c4cMode: PropTypes.string,
  handleCartToggle: PropTypes.func,
};

// Below helper functions not being used bc not tracking 'Product Viewed'
// const formatCategory = listUrl => {
//   const listUrlArray = listUrl.split('/');
//   return listUrlArray[listUrlArray.length - 1];
// };

// const handlePage = itemProperties => {
//   switch (true) {
//     case itemProperties.relatedItem === true: {
//       return 'Related Products';
//     }
//     case itemProperties.imageGallery === true: {
//       return 'Image Gallery';
//     }
//     default:
//       return 'Products Catalog';
//   }
// };

class ProductListItem extends Component {
  static defaultProps = {
    isVerticallyCentered: false,
  };

  handleLogin = () => {
    const { handleRouteChange } = this.props;
    const redirectUrl = encodeURI(window.location.href);
    handleRouteChange(`/login?redirect_uri=${redirectUrl}`);
  };

  isGatedPCProduct = () => {
    const { product } = this.props;
    const productRequiresPcRole =
      product &&
      product.productPermissions &&
      product.productPermissions.oneCommerce &&
      product.productPermissions.oneCommerce.preferredCustomer;
    return productRequiresPcRole;
  };

  getCurrentUser = () => {
    const { user, user: { conciergeUser } } = this.props;
    const currentUser =
      conciergeUser && conciergeUser.userId ? conciergeUser : user;
    return currentUser;
  };

  userAlreadyEnrolledInSubscriptionProduct = () => {
    // Is this going to slow the site down even more?

    // PC Subscription
    // Old CE's wont have subscription until they purchase their first order.
    // So we have to base it on role. We maybe should fix this with a script.
    if (
      this.props.product.productId === subscriptionProductIds.preferredCustomer
    ) {
      // return this.userIsPC();
    }

    // All other subscriptions
    const currentUser = this.getCurrentUser();
    const {
      enrollmentStatus,
      subscriptionStatus,
    } = currentUser.subscriptions.wineClub;
    if (enrollmentStatus && subscriptionStatus) {
      if (
        enrollmentStatus === 'cancelled' &&
        subscriptionStatus === 'cancelled'
      ) {
        return false;
      }
      return true;
    }

    return false;
  };

  // userIsPC = () => {
  //   const currentUser = this.getCurrentUser();
  //   const hasPreferredCustomer =
  //     currentUser.permissions &&
  //     currentUser.permissions.oneCommerce &&
  //     currentUser.permissions.oneCommerce.preferredCustomer &&
  //     currentUser.permissions.oneCommerce.preferredCustomer.access;
  //   // return hasPreferredCustomer;
  //   const hasPreferredCustomerInCart = false;
  //   return hasPreferredCustomer || hasPreferredCustomerInCart;
  // };

  getAddedProductText = (cartQty: number) => {
    const { product } = this.props;
    const isInCart = cartQty > 0;
    // Cannot enroll in duplicate subscriptions currently
    if (product.isSubscription) {
      if (this.userAlreadyEnrolledInSubscriptionProduct()) {
        return 'LEARN MORE';
      }
      if (isInCart) {
        return 'REMOVE';
      }
    }

    if (isInCart) {
      return `CART (${cartQty})`;
    }

    return '';
  };

  getAddProductText = () => {
    if (
      this.props.product.productId === subscriptionProductIds.preferredCustomer
    ) {
      return 'JOIN THE CLUB';
    }

    // if (this.isGatedPCProduct() && !this.userIsPC()) {
    //   return 'JOIN THE CLUB';
    // }

    return 'ADD TO CART';
  };

  onProductClick = e => {
    e.preventDefault();
    return this.onProductClickImage(e);
  };

  onProductClickImage = e => {
    e.preventDefault();
    const { handleRouteChange, product, category } = this.props;
    if (product.staticUrl) {
      return handleRouteChange(product.staticUrl);
    }
    return handleRouteChange(
      `/shop/product/${product.productURLslug}`,
      category,
    );
  };

  handleCartAddClick = (e, cartQty) => {
    e.preventDefault();
    const { handleCartAddClick, product } = this.props;
    // Cannot enroll in duplicate subscriptions currently; make it a toggle button.
    // This is slow so rageclicking needs to prevent multiple additions by cart logic.

    if (product.isSubscription) {
      // const cartQty = user.cart
      //   ? findProductCartQty(product.productId, user.cart.entriesV2)
      //   : 0;

      const buttonText = this.getAddedProductText(cartQty);
      if (buttonText === 'LEARN MORE') {
        return this.onProductClick(e);
      }
      if (buttonText === 'REMOVE') {
        return this.handleRemoveFromCartClick(e, cartQty);
      }
    }
    handleCartAddClick({ product, qty: cartQty, qtyChange: 1 });
  };

  handleRemoveFromCartClick = (e, cartQty) => {
    e.preventDefault();
    const { product, handleCartAddClick } = this.props;
    handleCartAddClick({ product, qty: cartQty, qtyChange: -1 });
  };

  getButtonStyles = () => {
    const { user, product, c4cMode } = this.props;
    return getButtonStyles(user, product, c4cMode);
  };

  getCurrentPrice = (product, viaQualifiedCartTotal) => {
    const { c4cMode } = this.props;
    return currentPrice(product, viaQualifiedCartTotal, c4cMode);
  };

  render() {
    const {
      containerWidth,
      handleCartAddClick,
      handleRouteChange,
      c4cMode,
      isVerticallyCentered,
      product,
      user,
      handleCartToggle,
    } = this.props;
    let { hidePlusMinus } = this.props;
    hidePlusMinus =
      hidePlusMinus || product.parentProduct || product.isSubscription;
    const { conciergeUser } = user;
    const viaQualifiedCartTotal =
      user && user.cartV2 && user.cartV2.discountQualifiedCartTotal;

    const prices = this.getCurrentPrice(product, viaQualifiedCartTotal);
    const priceMin = product.priceUSDmin ? product.priceUSDmin.toFixed(2) : '';
    const priceMax = product.priceUSDmax ? product.priceUSDmax.toFixed(2) : '';
    const cartQty = user.cartV2
      ? findProductCartQty(product.productId, user.cartV2.entries)
      : 0;

    const isInCart = cartQty > 0;
    const addToCartButtonText =
      this.getAddedProductText(cartQty) || this.getAddProductText();
    const {
      name,
      images,
      content,
      inventoryText,
      // reviewAverage,
      inventoryQuantity,
      // reviewTotal,
      freeUpsGroundShipping,
    } = product;
    const impactSmall = content ? content.impactSmall : null;
    const productCatalog = images ? images.squareFront : null;
    const { color, borderColor, backgroundColor } = this.getButtonStyles();
    const isConcierge = conciergeUser && conciergeUser.userId;
    const nonEligibleSku = getNonEligibleSkuText(product, c4cMode);
    return (
      <div className="Product entry">
        <ProductListImage
          {...{
            name,
            urlShopProduct: urlSquareShopProduct,
            productCatalog,
            freeUpsGroundShipping,
            handleRouteChange,
            onProductClick: this.onProductClickImage,
          }}
        />
        <Box className="Product-summary-container">
          <Flex
            className="Product--customActions"
            justify={isVerticallyCentered ? 'center' : 'space-between'}>
            <Box className="Product--name" pr={1}>
              <a onClick={this.onProductClick}>
                <ProductListItemName
                  text={name}
                  {...{ isVerticallyCentered }}
                />
              </a>
            </Box>
          </Flex>
          <Flex justify={isVerticallyCentered ? 'center' : 'space-between'}>
            {product.parentProduct && priceMin !== priceMax
              ? <Flex>
                  <Box className="Product--price">
                    ${priceMin} - ${priceMax}
                  </Box>
                </Flex>
              : <Flex>
                  {prices.isSale &&
                    <Box style={{ marginTop: 5 }}>
                      <span className="Product--salePrice">
                        ${prices.priceRetail}
                      </span>
                      <span className="redSalePrice">
                        ${prices.price}
                      </span>
                    </Box>}
                  {!prices.isSale &&
                    <Box className="Product--price">
                      ${prices.price}
                    </Box>}
                </Flex>}
            {freeUpsGroundShipping &&
              <Flex align="center" className="Product--shipsFree">
                1 CENT SHIP!
              </Flex>}
          </Flex>
        </Box>
        <Flex
          justify={isVerticallyCentered ? 'center' : 'flex-start'}
          align="flex-start">
          <ImpactText {...{ impactSmall }} />
        </Flex>
        {isFunction(handleCartAddClick)
          ? <div>
              <ProductListItemToggleButton
                {...{
                  hidePlusMinus,
                  product,
                  isInCart,
                  color,
                  borderColor,
                  backgroundColor,
                  inventoryText,
                  containerWidth,
                  inventoryQuantity,
                  addToCartButtonText,
                  cartQty,
                  onProductClick: this.onProductClick,
                  handleCartAddClick: this.handleCartAddClick,
                  handleRemoveFromCartClick: this.handleRemoveFromCartClick,
                  handleCartToggle,
                }}
              />
              <Flex align="center" justify="center">
                <Box className="non-eligible-sku-text">
                  {nonEligibleSku}
                </Box>
              </Flex>
            </div>
          : null}
      </div>
    );
  }
}

ProductListItem.propTypes = propTypes;

export default createFragmentContainer(withCase4CauseToggle(ProductListItem), {
  user: graphql`
    fragment ProductListItem_user on User {
      id
      role
      conciergeCustomerAccountId
      conciergeUser {
        id
        userId
        permissions {
          id
          oneCommerce {
            id
            preferredCustomer {
              access
            }
          }
        }
        subscriptions {
          wineClub {
            enrollmentStatus
            subscriptionStatus
          }
        }
      }
      cartV2 {
        id
        cartId
        discountQualifiedCartTotal
        entries(first: 1000) {
          edges {
            node {
              id
              sku
              productId
              quantity
              productName
              productURLslug
              productImageUrl
              wineBottleQuantity
              isWinePack
              priceOriginal
              priceSale
              priceDiscount
              discountEligible
              priceDiscountPercent
              hasQualifyingDiscount
            }
          }
        }
      }
      subscriptions {
        wineClub {
          enrollmentStatus
          subscriptionStatus
        }
      }
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
        }
      }
    }
  `,
  product: graphql`
    fragment ProductListItem_product on Product {
      id
      isSubscription
      productPermissions {
        oneCommerce {
          preferredCustomer {
            view
            add
          }
          default {
            view
            add
          }
        }
      }
      ranking
      company
      freeUpsGroundShipping
      productId
      name
      category
      price
      priceUSDmin
      priceUSDmax
      year
      priceSale
      reviewAverage
      productURLslug
      parentProduct
      inventoryText
      reviewTotal
      staticUrl
      images {
        productCatalog
        squareFront
      }
      content {
        impactSmall
        summary
      }
      promoCodeDiscount {
        case4Cause {
          case12PriceUSD
          case6PriceUSD
          case6SKU
          case12SKU
          donationEligible
        }
      }
      company
      inventoryClass
      inventorySKU
      inventoryQuantity
    }
  `,
});
